<template>
  <div class="create-post">
    <div class="nav-wrap">
      <p v-if="userinfo" class="title">Signed in as:&nbsp;<span class="button-text" @click="toggleLogin">{{ userinfo.firstname }}</span></p>
      <p v-else class="title">
        <span class="active-color">You have to</span>
        <span class="button-text" @click="toggleLogin(); showSignUp('join');">&nbsp;Join&nbsp;</span>
        <span>/</span>
        <span class="button-text" @click="toggleLogin(); showSignUp('login');">&nbsp;Login&nbsp;</span> 
        <span class="active-color">to post</span>
      </p>
      <div class="close" @click="toggleCreatePost">
        <IconCancel class="icon-cancel" />
      </div>
    </div>
    
    <form class="form" @submit.prevent="createPost" autocomplete="off">

        <div>
          <p class="minor">YouTube URL<span class="active-color">*</span></p>
          <input type="text" placeholder="https://www..." v-model="LinkToVideo">
        </div>

        <div class="debater">
          <div class="deb-list">
            <p class="minor">Add Debater<span class="active-color">*</span></p>
            <div class="custom-dropdown">
              <select v-model="debater1">
                <option :value="null">Choose</option>
                <option v-for="i in debList" :key="i.key">{{i.name}}</option>
              </select>
            </div>
          </div>
          <div class="deb-input">
            <p class="minor">If not found in list</p>
            <input type="text" placeholder="Name..." v-model="debater1">
          </div>
        </div>
        <!-- <p>VS.</p> -->
        <div class="debater">
          <div class="deb-list">
            <p class="minor">Add Debater</p>
            <div class="custom-dropdown">
              <select v-model="debater2">
                <option :value="null">Choose</option>
                <option v-for="i in debList" :key="i.key">{{i.name}}</option>
              </select>
            </div>
          </div>
          <div class="deb-input">
            <p class="minor">If not found in list</p>
            <input type="text" placeholder="Name..." v-model="debater2">
          </div>
        </div>


        <div>
          <p class="minor">Title<span class="active-color">*</span></p>
          <input type="text" placeholder="Max 120 characters..." v-model="title">
        </div>
        <div>
          <p class="minor">Description</p>
          <textarea type="text" placeholder="Max 440 characters..." v-model="desc">
          </textarea>
        </div>
        <div>
          <p class="minor">Tags</p>
          <input type="text" placeholder="E.g. #SlavojZizek, #Politics..." v-model="tags">
        </div>

        <!-- Errors -->
        <p v-if="errors.length"><b>Please correct the following error(s):</b><ul><li v-for="error in errors" :key="error.key" class="active-color">{{ error }}</li></ul></p>
  
      <button v-if="userinfo" class="button" type="submit">CREATE POST</button>
      <div v-if="!userinfo" class="button disabled-button" @click="togglePopMess('You have to Login to Post')">CREATE POST</div>

    </form>


  </div>
</template>

<script>
import { db, auth, time, fbfs } from '../db'
import * as firebase from 'firebase'
import IconCancel from '../assets/icons/IconCancel.vue'

export default {
  name: 'CreatePost',
  props: [
    "userinfo"
  ],
  components: {
    IconCancel
  },
  fiery: true, // required to add this.$fiery to this component
  data() {
    return {
      LinkToVideo: '',
      tags: '',
      title: '',
      desc: '',
      author: '',
      debater1: null,
      debater2: null,
      debaters:[],
      errors:[],
      // debaterList: this.$fiery(db.collection('debaters'), {key: 'id', propExists: 'exists', exclude: ['id', 'exists']}), // must be excluded manually from saving if include is not specified      
    }
  },
  computed: {
    debList() {
      return this.$store.state.debaterProfiles
    }
  },
  methods: {
    toggleCreatePost() {
      this.$store.commit('toggleCreatePost')
    },
    toggleLogin(payload) {
      this.$store.commit('toggleLogin', payload)
    },
    showSignUp(payload) {
      this.$store.commit('showSignUp', payload)
    },
    togglePopMess(payload) {
      this.$store.commit('togglePopMess', payload)
    },
    createPost() {
      if (!this.LinkToVideo) {
        this.errors.push("A post need a link to a video")
      } 
      else if (!this.debater1) {
        this.errors.push("A post need atleast one debater")
      }
      else {
        if (this.userinfo) {
        // User is signed in.
            db.collection('posts')
            .add({
              author: {
                firstname: this.userinfo.firstname,
                lastname: this.userinfo.lastname,
                id: this.userinfo.id
              },
              debaters:{
                1: {
                  name: this.debater1,
                  voteCount: 0,
                  parentRef: 1
                },
                2: {
                  name: this.debater2,
                  voteCount: 0,
                  parentRef: 2
                }
              },
              link: this.LinkToVideo,
              tags: this.tags,
              title: this.title,
              desc: this.desc,
              timeStamp: time,
              likeCount: 0,
              dislikeCount: 0,
              commentCount: 0,
              comments: [],
            })
            .then(ref => { 

              const debProfiles = db.collection('highscore').doc('profiles')
              
              if (this.debater1) {

                var that = this
                var searchDebList = that.debList.find(obj => { return obj.name == that.debater1 })

                if (!searchDebList) {
                    // New profile
                    console.log('New profile')
                    debProfiles.set({
                      [that.debater1]: {
                          name: that.debater1,
                          totalvotes: 0,
                          added: time,
                          debates: { 
                            [ref.id]: {
                              vs: this.debater2,
                              votes: 0,
                            }
                          }
                        }
                    }, {merge: true})
                      .then(() => {
                        console.log('+1 Write() Highscore Debater 1 added')
                    }).catch(err => { console.error(err) })

                } else {
                    // Existing profile
                    console.log('Existing profile');
                    debProfiles.set({
                      [that.debater1]: {
                        debates: { 
                          [ref.id]: {
                            vs: this.debater2,
                            votes: 0,
                          }
                        }
                      }
                    }, {merge: true})
                    .then(() => { 
                      console.log('+1 Write() Debater 1 updated') 
                    }).catch(err => { console.error(err) })
                }
              } else {
                console.log('Debater 1 input field empty')
              }

              if (this.debater2) {

                  var that = this
                  var searchDebList = that.debList.find(obj => { return obj.name == that.debater2 })
                  
                  if (!searchDebList) {
                      console.log('New debater')
                        debProfiles.set({
                          [that.debater2]: {
                              name: that.debater2,
                              totalvotes: 0,
                              added: time,
                              debates: { 
                                [ref.id]: {
                                  vs: this.debater1,
                                  votes: 0,
                                }
                              }
                            }
                        }, {merge: true})
                        .then(() => {
                          console.log('+1 Write() Highscore Debater 2 added')
                      }).catch(err => { console.error(err) })
                  } else {
                      // Existing profile
                      console.log('Existing profile');
                      debProfiles.set({
                        [that.debater2]: {
                          debates: { 
                            [ref.id]: {
                              vs: this.debater1,
                              votes: 0,
                            }
                          }
                        }
                      }, {merge: true})
                      .then(() => { 
                        console.log('+1 Write() Debater 2 updated') 
                      }).catch(err => { console.error(err) })
                  }
                } else {
                  console.log('Debater 2 input field empty')
                }

              console.log('Post successful')
              this.$router.go(0)

            })
            .catch(err => { console.error(err) })
        } else {
          // No user is signed in.
            console.log('You have to login to post')
        }

      }

    }

  }
}
</script>
<style lang="scss" scoped>
// @import "../scss/_variables.scss";
.create-post {
  position: fixed;
  height: 100%;
  overflow-y: scroll;
  background-color: $white;
  border-left: $line-bold solid $line-color-dark;
  right: 0;
  // width: calc(#{$col6} + #{$grid-padding});
  width: 50%;
  z-index: 30;
  .nav-wrap {
    position: fixed;
    background-color: white;
    width: 50vw;
    height: $nav-height;
    border-bottom: $line-bold solid $line-color-dark;
    display: flex;
    align-items: center;
    justify-content: space-between;
    z-index: 31;
    .title {
      margin-left: $main-margin;
      display: flex;
    }
    .close {
      margin-right: $main-margin;
      display: flex;
      align-items: center;
      .icon-cancel {
        padding: 0;
      }
    }
  }
  .form {
    margin: $nav-height $grid-padding $nav-height $main-margin;
    .debater {
      display: flex;
      justify-content: space-between;
      .deb-input {
        width: 50%;
        margin-left: $main-margin;
      }
    }
    .button {
      height: $nav-height;
      margin-top: calc(#{$main-margin} * 2);
      width: 100%;
    }

/* Custom dropdown */
.custom-dropdown {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  // width: $col3;
  width: calc((50vw - ((#{$main-margin} * 2) + #{$grid-padding})) / 2);
  @media #{$mobile} {  width: auto;  }
  border-bottom: $line-bold solid $line-color-dark;
}
.custom-dropdown select {
  font-family: $family;
  font-size: $p1;
  font-weight: $bold;
  color: $p-color;
  background-color: transparent;
  width: 100%;
  line-height: 40px;
  padding-right: 2.5em;	
  border: 0;
  margin: 0;
  border-radius: 0;
  text-indent: 0.01px;
  text-overflow: '';
  appearance: none; -moz-appearance: none; -webkit-appearance:none;
}
/*Hiding the select arrow for IE10*/
.custom-dropdown select::-ms-expand {
    display: none;
}
.custom-dropdown::before,
.custom-dropdown::after {
  content: "";
  position: absolute;
  pointer-events: none;
}
.custom-dropdown::after { /*  Custom dropdown arrow */
  content: "\25BC";
  height: 1em;
  font-size: .625em;
  line-height: 1;
  right: 1.2em;
  top: 50%;
  margin-top: -.5em;
}
.custom-dropdown::before { /*  Custom dropdown arrow cover */
  width: 2em;
  right: 0;
  top: 0;
  bottom: 0;
  // background-color: rgba(0,0,0,.2);
}
.custom-dropdown::after {
  color: rgba(0,0,0,.6);
}
.custom-dropdown select[disabled] {
  color: rgba(0,0,0,.25);
}


  }
}

// MOBILE
@media #{$mobile} {    
    .create-post {
      width: 100%;
      .form {
        margin: $nav-height-mobile $main-margin-mobile;
      }
      .nav-wrap { 
        width: 100%;
        height: $nav-height-mobile;
        .title {
          margin-left: $main-margin-mobile;
        }
        .close {
          margin-right: $main-margin-mobile;
        }
      }
      .content-wrap {
        margin: $nav-height-mobile $main-margin-mobile;
      }  
    }    
}

</style>

